__turbopack_context__.v({
  "className": "nunito_sans_f5735027-module__r-tewa__className",
  "variable": "nunito_sans_f5735027-module__r-tewa__variable",
});
